import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { LogService } from './log.service';
import { IComponentEntitlementService } from '../interfaces/component-entitlement.abstract.service';
import { ServiceRouter } from '../utils/service-router';
import { ServiceDefinition } from '../service-definitions/service-definition';
import { EntitlementMetadata } from '../models/entitlement-metadata.model';

const ENTITLEMENTS_ENDPOINT = '/actuator/entitlements-metadata';
@Injectable()
export class ComponentEntitlementService implements IComponentEntitlementService {
    private baseUrl: string;
    private dataStore: Map<string, string[]>;
    private _loaded: BehaviorSubject<any>;

    constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter) {
        this._loaded = new BehaviorSubject(null);
    }

    init(serviceDefinition: ServiceDefinition): any {
        if (this.serviceRouter) {
            this.baseUrl = this.serviceRouter.getServiceRouteURL(serviceDefinition);
            return this.getEntitlementsForAllComponents();
        } else {
            return null;
        }
    }

    hasRole(componentName: string, role: string): boolean {
        if (this.dataStore != null) {
            return this.dataStore.get(componentName) && this.dataStore.get(componentName).indexOf(role) > -1;
        }
        return false;
    }

    getEntitlements(): Observable<any> {
        return this._loaded.asObservable();
    }


    /**
     * Make the call to get the entitlements for all components. Asynchronous.
     */
    private getEntitlementsForAllComponents(): void {
        if (this.dataStore == null) {
            let promise = this.http.get(this.baseUrl + ENTITLEMENTS_ENDPOINT, { responseType: 'json' }).toPromise();
            promise.then((response: EntitlementMetadata[]) => {
                this.loadInDataStore(response);
                this._loaded.next(true);
            }, error => {
                this.logService.error(`Error in retrieving entitlements for feature components. Error message: ${error.message}`);
                this._loaded.next(false);
            });
        }
    }


    private loadInDataStore(componentMetadataList: EntitlementMetadata[]) {
        this.dataStore = new Map<string, string[]>();
        componentMetadataList.forEach((componentMetadata: EntitlementMetadata) => {
            this.dataStore.set(componentMetadata.name, componentMetadata.entitlements);
        });
    }

}
